import React from 'react';
import SideNavbar from '../common/SideNavBar/SideNavbar';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const WrapperComponent = ({ children }) => {
  const location = useLocation().pathname.split('/').splice(1);
   const token = localStorage.getItem('Quixtoken')
    ? JSON.parse(localStorage.getItem('Quixtoken'))
    : null;

  const {tokenState} = useSelector((state)=>state.Auth);

  // 🔒 Protect all wrapped routes
  if (!tokenState || !token){
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {
      // !location.includes('login') ? ( 
        <>
          <SideNavbar />
          <div className="WrapperArea">
            <div className="WrapperBox">{children}</div>
          </div>
        </>
      // ) : (
      //   <div>{children}</div>
      // )
      }
    </>
  );
};

export default WrapperComponent;
